module.exports = __webpack_public_path__ + "img/KSC00993.ca6353de.jpg";